import type React from "react";
import type { IconProps } from "./Icon.model";
import { StyledIcon } from "./Icon.styled";

export const Icon: React.FC<IconProps> = ({ dataCy, className }) => (
  <StyledIcon className={className} data-cy={dataCy} />
);

export default Icon;
